/** @var string Работник склада */
export const WAREHOUSE_WORKER = 'warehouse_worker';

export const BUYER = 'buyer';

export const CONSIGNOR_DIRECTOR = 'consignor_director';